import { __awaiter } from "tslib";
import { LoadedState, ReadyState } from "./shared.types.js";
const isNotLoadedOrFailedToLoad = (loadedState) => loadedState === LoadedState.NOT_LOADED || loadedState === LoadedState.FAILED_TO_LOAD_IN_BROWSER;
const isNotReadyOrFailedToLoad = (readyState, loadedState) => readyState === ReadyState.NOT_READY || loadedState === LoadedState.FAILED_TO_LOAD_IN_BROWSER;
const waitFor = (ms) => __awaiter(void 0, void 0, void 0, function* () { return new Promise((resolve) => setTimeout(resolve, ms)); });
const timeoutByConnection = () => __awaiter(void 0, void 0, void 0, function* () {
    const connection = window.navigator.connection;
    let timeout;
    switch (connection === null || connection === void 0 ? void 0 : connection.effectiveType) {
        case 'slow 2g':
        case 'slow-2g':
            timeout = 45000;
            break;
        case '2g':
            timeout = 27500;
            break;
        case '3g':
            timeout = 9500;
            break;
        default:
            timeout = 3000;
    }
    return waitFor(timeout);
});
export { isNotLoadedOrFailedToLoad, isNotReadyOrFailedToLoad, timeoutByConnection };
//# sourceMappingURL=shared.helpers.js.map